import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from "react";
import BootstrapWidgets from "../widgets";
import { BasicConfig } from "@react-awesome-query-builder/ui";
var settings = _objectSpread(_objectSpread({}, BasicConfig.settings), {}, {
  renderField: function renderField(props, _ref) {
    var RCE = _ref.RCE,
      BootstrapFieldSelect = _ref.W.BootstrapFieldSelect;
    return RCE(BootstrapFieldSelect, props);
  },
  renderOperator: function renderOperator(props, _ref2) {
    var RCE = _ref2.RCE,
      BootstrapFieldSelect = _ref2.W.BootstrapFieldSelect;
    return RCE(BootstrapFieldSelect, props);
  },
  renderFunc: function renderFunc(props, _ref3) {
    var RCE = _ref3.RCE,
      BootstrapFieldSelect = _ref3.W.BootstrapFieldSelect;
    return RCE(BootstrapFieldSelect, props);
  },
  renderConjs: function renderConjs(props, _ref4) {
    var RCE = _ref4.RCE,
      BootstrapConjs = _ref4.W.BootstrapConjs;
    return RCE(BootstrapConjs, props);
  },
  renderButton: function renderButton(props, _ref5) {
    var RCE = _ref5.RCE,
      BootstrapButton = _ref5.W.BootstrapButton;
    return RCE(BootstrapButton, props);
  },
  renderButtonGroup: function renderButtonGroup(props, _ref6) {
    var RCE = _ref6.RCE,
      BootstrapButtonGroup = _ref6.W.BootstrapButtonGroup;
    return RCE(BootstrapButtonGroup, props);
  },
  renderValueSources: function renderValueSources(props, _ref7) {
    var RCE = _ref7.RCE,
      BootstrapValueSources = _ref7.W.BootstrapValueSources;
    return RCE(BootstrapValueSources, props);
  },
  renderFieldSources: function renderFieldSources(props, _ref8) {
    var RCE = _ref8.RCE,
      BootstrapValueSources = _ref8.W.BootstrapValueSources;
    return RCE(BootstrapValueSources, props);
  },
  renderProvider: function renderProvider(props, _ref9) {
    var RCE = _ref9.RCE,
      BootstrapProvider = _ref9.W.BootstrapProvider;
    return RCE(BootstrapProvider, props);
  },
  renderConfirm: function renderConfirm(props, _ref10) {
    var BootstrapConfirm = _ref10.W.BootstrapConfirm;
    return BootstrapConfirm(props);
  }
});
var widgets = _objectSpread(_objectSpread({}, BasicConfig.widgets), {}, {
  text: _objectSpread(_objectSpread({}, BasicConfig.widgets.text), {}, {
    factory: function factory(props, _ref11) {
      var RCE = _ref11.RCE,
        BootstrapTextWidget = _ref11.W.BootstrapTextWidget;
      return RCE(BootstrapTextWidget, props);
    }
  }),
  textarea: _objectSpread(_objectSpread({}, BasicConfig.widgets.textarea), {}, {
    factory: function factory(props, _ref12) {
      var RCE = _ref12.RCE,
        BootstrapTextAreaWidget = _ref12.W.BootstrapTextAreaWidget;
      return RCE(BootstrapTextAreaWidget, props);
    }
  }),
  number: _objectSpread(_objectSpread({}, BasicConfig.widgets.number), {}, {
    factory: function factory(props, _ref13) {
      var RCE = _ref13.RCE,
        BootstrapNumberWidget = _ref13.W.BootstrapNumberWidget;
      return RCE(BootstrapNumberWidget, props);
    }
  }),
  multiselect: _objectSpread(_objectSpread({}, BasicConfig.widgets.multiselect), {}, {
    factory: function factory(props, _ref14) {
      var RCE = _ref14.RCE,
        BootstrapMultiSelectWidget = _ref14.W.BootstrapMultiSelectWidget;
      return RCE(BootstrapMultiSelectWidget, props);
    }
  }),
  select: _objectSpread(_objectSpread({}, BasicConfig.widgets.select), {}, {
    factory: function factory(props, _ref15) {
      var RCE = _ref15.RCE,
        BootstrapSelectWidget = _ref15.W.BootstrapSelectWidget;
      return RCE(BootstrapSelectWidget, props);
    }
  }),
  slider: _objectSpread(_objectSpread({}, BasicConfig.widgets.slider), {}, {
    factory: function factory(props, _ref16) {
      var RCE = _ref16.RCE,
        BootstrapSliderWidget = _ref16.W.BootstrapSliderWidget;
      return RCE(BootstrapSliderWidget, props);
    }
  }),
  "boolean": _objectSpread(_objectSpread({}, BasicConfig.widgets["boolean"]), {}, {
    factory: function factory(props, _ref17) {
      var RCE = _ref17.RCE,
        BootstrapBooleanWidget = _ref17.W.BootstrapBooleanWidget;
      return RCE(BootstrapBooleanWidget, props);
    }
  }),
  date: _objectSpread(_objectSpread({}, BasicConfig.widgets.date), {}, {
    factory: function factory(props, _ref18) {
      var RCE = _ref18.RCE,
        BootstrapDateWidget = _ref18.W.BootstrapDateWidget;
      return RCE(BootstrapDateWidget, props);
    }
  }),
  time: _objectSpread(_objectSpread({}, BasicConfig.widgets.time), {}, {
    factory: function factory(props, _ref19) {
      var RCE = _ref19.RCE,
        BootstrapTimeWidget = _ref19.W.BootstrapTimeWidget;
      return RCE(BootstrapTimeWidget, props);
    }
  }),
  datetime: _objectSpread(_objectSpread({}, BasicConfig.widgets.datetime), {}, {
    factory: function factory(props, _ref20) {
      var RCE = _ref20.RCE,
        BootstrapDateTimeWidget = _ref20.W.BootstrapDateTimeWidget;
      return RCE(BootstrapDateTimeWidget, props);
    }
  })
});
var types = _objectSpread({}, BasicConfig.types);
var ctx = _objectSpread(_objectSpread({}, BasicConfig.ctx), {}, {
  W: _objectSpread(_objectSpread({}, BasicConfig.ctx.W), BootstrapWidgets)
});
var config = _objectSpread(_objectSpread({}, BasicConfig), {}, {
  ctx: ctx,
  types: types,
  widgets: widgets,
  settings: settings
});
export default config;